module.exports = __webpack_public_path__ + "static/media/crossBlack.7da5fdeb.svg";